interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const SmallStarIcon = (props: PropsType) => {
  return (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.73871 0L10.7007 6.21885H17.0497L11.9132 10.0623L13.8752 16.2812L8.73871 12.4377L3.60222 16.2812L5.56419 10.0623L0.427703 6.21885H6.77674L8.73871 0Z"
        fill="white"
      />
    </svg>
  );
};

export default SmallStarIcon;
